/* Duskwell storefront behaviour — small, dependency-free */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- Mobile menu drawer ---------- */
  var drawer = $('[data-dw-drawer]');
  var opener = $('[data-dw-open-menu]');
  function setMenu(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (opener) opener.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) { var f = $('a, button', drawer.querySelector('.dw-drawer__panel')); if (f) f.focus(); }
    else if (opener) opener.focus();
  }
  if (opener) opener.addEventListener('click', function () { setMenu(true); });
  $$('[data-dw-close-menu]').forEach(function (el) { el.addEventListener('click', function () { setMenu(false); }); });

  /* ---------- Product page ---------- */
  var pdp = $('[data-dw-product]');
  if (pdp) {
    var track = $('[data-dw-track]', pdp);
    var slides = track ? $$('.dw-gal__slide', track) : [];
    var dots = $$('.dw-gal__dots span', pdp);
    var thumbs = $$('[data-dw-thumb]', pdp);
    var current = 0;
    function goTo(i, smooth) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(i);
    }
    function mark(i) {
      current = i;
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      });
    }
    var prev = $('[data-dw-prev]', pdp), next = $('[data-dw-next]', pdp);
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-dw-thumb'), 10)); }); });

    /* Variants, colour chips, bundles */
    var variants = [];
    try { variants = JSON.parse($('[data-dw-variants]', pdp).textContent); } catch (e) {}
    var form = $('[data-dw-form]', pdp) || $('#dw-pf');
    var idInput = $('[data-dw-variant-id]', pdp);
    var atc = $('[data-dw-atc]', pdp);
    var atcLabel = $('[data-dw-atc-label]', pdp);
    var atcSub = $('[data-dw-atc-sub]', pdp);
    var stickyAtc = $('[data-dw-sticky-atc]', pdp);
    var qty = $('[data-dw-qty-input]', pdp);
    var atcText = atcLabel ? atcLabel.textContent : 'Add to cart';
    var bundles = $$('[data-dw-bundle]', pdp);
    var moneyFmt = function (c) {
      var n = (Math.round(c) / 100).toFixed(2);
      var tpl = (window.Shopify && Shopify.currency && Shopify.currency.active === 'EUR') ? '€' : '$';
      return tpl + n;
    };
    function selected() {
      return $$('[data-dw-optgroup]', pdp).map(function (g) { var r = $('input:checked', g); return r ? r.value : ''; });
    }
    function currentVariant() {
      var opts = selected();
      return variants.filter(function (x) { return x.options.join('||') === opts.join('||'); })[0];
    }
    function bundleQty() { var b = bundles.filter(function (x) { return x.checked; })[0]; return b ? parseInt(b.value, 10) : 1; }
    function setText(sel, txt) { var el = $(sel, pdp); if (el) { if (txt === null) { el.hidden = true; } else { el.hidden = false; el.textContent = txt; } } }
    function refreshBundles(v) {
      var q = bundleQty();
      if (qty) qty.value = q;
      bundles.forEach(function (b) {
        var card = b.closest('.dw-bundle'); if (!card) return;
        card.classList.toggle('is-active', b.checked);
        if (!v) return;
        var n = parseInt(b.value, 10), off = parseInt(b.getAttribute('data-off'), 10) || 0;
        var bsave = Math.round(v.cents * n * off / 1000), total = v.cents * n - bsave;
        var t = $('[data-dw-btotal]', card); if (t) t.textContent = moneyFmt(total);
        var sv = $('[data-dw-bsave]', card); if (sv) sv.textContent = 'You save ' + moneyFmt(bsave);
        var w = $('[data-dw-bwas]', card); if (w && v.was_cents > v.cents) w.textContent = moneyFmt(v.was_cents * n);
      });
      if (v && atcSub) {
        var off = 0; bundles.forEach(function (b) { if (b.checked) off = parseInt(b.getAttribute('data-off'), 10) || 0; });
        var base = v.was_cents > v.cents ? v.was_cents : v.cents;
        var save = base * q - (v.cents * q - Math.round(v.cents * q * off / 1000));
        atcSub.hidden = save <= 0;
        atcSub.textContent = 'You save ' + moneyFmt(save) + ' today';
      }
    }
    function update() {
      var v = currentVariant();
      $$('[data-dw-opt-label]', pdp).forEach(function (l) { l.textContent = selected()[parseInt(l.getAttribute('data-dw-opt-label'), 10)] || ''; });
      if (!v) {
        if (atc) { atc.disabled = true; atcLabel.textContent = 'Unavailable'; }
        if (stickyAtc) stickyAtc.disabled = true;
        return;
      }
      idInput.value = v.id;
      setText('[data-dw-now]', v.price);
      setText('[data-dw-was]', v.compare);
      setText('[data-dw-savebadge]', v.was_cents > v.cents ? 'Save ' + moneyFmt(v.was_cents - v.cents).replace('.00', '') : null);
      setText('[data-dw-sticky-now]', v.price);
      setText('[data-dw-sticky-was]', v.compare);
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? atcText : 'Sold out';
      if (stickyAtc) stickyAtc.disabled = !v.available;
      var stock = $('[data-dw-stock]', pdp);
      if (stock) {
        var th = parseInt(stock.getAttribute('data-threshold'), 10) || 25;
        var low = v.inv !== null && v.inv > 0 && v.inv <= th;
        stock.classList.toggle('is-low', low);
        stock.innerHTML = low ? '<i></i>Low stock: only ' + v.inv + ' left in ' + v.title : (v.available ? '<i></i>In stock and ready to ship' : 'Currently sold out');
      }
      refreshBundles(v);
      if (v.media) {
        var idx = slides.map(function (s) { return s.getAttribute('data-media-id'); }).indexOf(String(v.media));
        if (idx > -1) goTo(idx);
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    $$('[data-dw-option]', pdp).forEach(function (r) { r.addEventListener('change', update); });
    bundles.forEach(function (b) { b.addEventListener('change', function () { refreshBundles(currentVariant()); }); });
    (function () {
      var cv = variants.filter(function (x) { return idInput && String(x.id) === String(idInput.value); })[0];
      if (cv && cv.media) {
        var idx = slides.map(function (s) { return s.getAttribute('data-media-id'); }).indexOf(String(cv.media));
        if (idx > 0 && /[?&]variant=/.test(window.location.search)) goTo(idx, false);
      }
      refreshBundles(cv);
    })();

    /* Add to cart: AJAX add then go to cart (falls back to normal form post) */
    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        if (e.submitter && e.submitter.closest && e.submitter.closest('.shopify-payment-button')) return;
        e.preventDefault();
        var err = $('[data-dw-error]', pdp);
        atc.disabled = true; atcLabel.textContent = 'Adding…';
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(qty.value, 10) || 1 }] })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
            window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
          })
          .catch(function (ex) {
            atc.disabled = false; atcLabel.textContent = atcText;
            if (err) { err.hidden = false; err.textContent = ex.message; }
          });
      });
    }

    /* Sticky add to cart (mobile) */
    var sticky = $('[data-dw-sticky]', pdp);
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyAtc) stickyAtc.tabIndex = show ? 0 : -1;
      });
      io.observe(atc);
      if (stickyAtc) stickyAtc.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
      });
    }
  }

  /* ---------- Cart page quantity steppers ---------- */
  var cartForm = $('[data-dw-cart]');
  if (cartForm) {
    var t;
    function submitUpdate() {
      clearTimeout(t);
      t = setTimeout(function () {
        var h = document.createElement('input'); h.type = 'hidden'; h.name = 'update'; h.value = '1';
        cartForm.appendChild(h); cartForm.submit();
      }, 450);
    }
    $$('[data-dw-cart-step]', cartForm).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentNode.querySelector('input');
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-dw-cart-step'), 10));
        submitUpdate();
      });
    });
    $$('input[name="updates[]"]', cartForm).forEach(function (i) { i.addEventListener('change', submitUpdate); });
  }

  /* ---------- Launch-offer popup ---------- */
  var pop = $('[data-dw-pop]');
  if (pop && !store.get('dw_pop_seen')) {
    var shown = false;
    var lastFocus = null;
    function open() {
      if (shown || document.querySelector('.dw-drawer.is-open')) return;
      shown = true; store.set('dw_pop_seen', '1');
      lastFocus = document.activeElement;
      pop.classList.add('is-open'); pop.setAttribute('aria-hidden', 'false');
      var c = $('[data-dw-pop-cta]', pop); if (c) c.focus();
    }
    function close() {
      pop.classList.remove('is-open'); pop.setAttribute('aria-hidden', 'true');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    $$('[data-dw-pop-close]', pop).forEach(function (b) { b.addEventListener('click', close); });
    var cta = $('[data-dw-pop-cta]', pop);
    if (cta) cta.addEventListener('click', function (e) {
      var target = new URL(cta.href, window.location.href);
      if (target.pathname === window.location.pathname && document.getElementById('dw-pf')) {
        e.preventDefault(); close();
        document.getElementById('dw-pf').scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });
    var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 15) * 1000;
    setTimeout(open, delay);
    if (window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) open(); });
    }
  }

  /* Date-limited notes (e.g. Christmas delivery line) */
  $$('[data-dw-until]').forEach(function (el) {
    var d = el.getAttribute('data-dw-until'); if (!d) return;
    var end = new Date(d + 'T23:59:59');
    if (!isNaN(end) && new Date() <= end) el.hidden = false;
  });

  /* Close drawer with Escape */
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) setMenu(false); });
})();
